import React from 'react';
import { SVGIcon } from '@peoplegrove/pg-components';
import clsx from 'clsx';
import classes from './CsatScore.module.scss';

function CsatScore({ score }) {
  if (!score) {
    return null;
  }

  let theme = 'neutral';
  if (score >= 4) {
    theme = 'success';
  } else if (score <= 2) {
    theme = 'warning';
  }

  return (
    <div className={clsx(classes.csatScoreBadge, classes[theme])}>
      <SVGIcon icon="pg-star" size={12} />
      <span>{score}/5</span>
    </div>
  );
}

export default CsatScore;
